import * as Page from "pages";
import { AuthLayout, GeneralLayout } from "utils";
import PrivateRoute from "./PrivateRoute";

const routes = [
  {
    path: "/",
    element: <GeneralLayout />,
    children: [
      {
        index: true,
        element: <Page.DashboardPage />,
        auth: true,
      },
      {
        path: "articles",
        element: <Page.ArticlesPage />,
        auth: true,
      },
      {
        path: "detail-article/:id",
        element: <Page.DetailArticlePage />,
        auth: true,
      },
      {
        path: "products/:id",
        element: <Page.ProductsPage />,
        auth: true,
      },
      {
        path: "detail-product/:id/:queryCategory",
        element: <Page.DetailProductPage />,
        auth: true,
      },
      {
        path: "get-products/:id",
        element: <Page.GetProductsPage />,
        auth: true,
      },
      {
        path: "categories/:id",
        element: <Page.CategoriesPage />,
        auth: true,
      },
      {
        path: "detail-category/:id",
        element: <Page.DetailCategoryPage />,
        auth: true,
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <Page.LoginPage />,
      },
    ],
  },
  {
    path: "*",
    element: <Page.NotFoundPage />,
  },
];

const authMap = (routes) =>
  routes.map((route) => {
    if (route?.auth) {
      route.element = <PrivateRoute>{route.element}</PrivateRoute>;
    }
    if (route?.children) {
      route.children = authMap(route.children);
    }
    return route;
  });

export default authMap(routes);
